<template>
  <div class="navbar-user">
    <div class="left">
      <div class="logo">HXMT User Center</div>
      <div class="nav-menu">
        <div 
          class="menu-item"
          :class="{'menu-active': activeMenu === 'usrceninfo'}"
          @click="changPage('usrceninfo')">
          {{$t('navBar.userCenterinfo')}}
        </div>
        <div 
          class="menu-item"
          :class="{'menu-active': activeMenu === 'applylist'}"
          @click="changPage('applylist')">
          {{$t('navBar.applylist')}}
        </div>
        <div 
          class="menu-item"
          :class="{'menu-active': activeMenu === 'dllist'}"
          @click="changPage('dllist')">
          {{$t('navBar.downloadlist')}}
        </div>
      </div>

    </div>

    <div class="right">
      <div 
          class="menu-item"
          @click="changPage('proposal')">
          {{$t('navBar.homepage')}}
      </div>
      <el-dropdown trigger="click" @command="changLanguage">
        <div class="select-language">
          <span>{{$t('navBar.language')}}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu class="top-bar-dropdown" slot="dropdown">
          <el-dropdown-item :disabled="language==='zh'" command="zh">
            中文
          </el-dropdown-item>
          <el-dropdown-item :disabled="language==='en'" command="en">
            English
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="click" v-if="userInfo" @command="handleCommand">
        <div class="user-wrapper">
          <span class="user-name">{{userInfo.truename}}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu class="top-bar-dropdown" slot="dropdown">
          <el-dropdown-item class="logout-link" command="/">{{$t('navBar.homepage')}}
            <!-- <a class="logout-link" href="/">主页</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/iapi/logout">{{$t('navBar.logout')}}
            <!-- <a class="logout-link" href="/iapi/logout">{{$t('navBar.logout')}}</a> -->
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <a class="login-link" v-else href="/iapi/login">{{$t('navBar.login')}}</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    activeMenu: {
      type: String,
      default: 'usrinfo',
    },
  },
  computed: {
    ...mapState([
      'userInfo',
      'language',
    ]),
  },
  methods: {
    changPage(name) {
      if (this.activeMenu !== name) {
        this.$router.push({name});
      }
    },
    changLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('setLanguage', lang);
    },
    handleCommand(param) {
      location.href = param;
    },
  },
};
</script>

<style scoped lang="scss">
.navbar-user {
  background-color: #0058a3;
  box-shadow: 0px 3px 16px rgba(0,0,0,0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 56px;
}
.left, .right {
  display: flex;
  align-items: center;
}
.right {
  justify-content: right;
}
.logo {
  margin-right: 56px;
  font-size: 26px;
  color: #fff;
  font-weight: 500;
}
.logo-img {
  margin-right: 56px;
}
.nav-menu {
  display: flex;
  height: 56px;
}
.menu-item {
  height: 56px;
  line-height: 56px;
  margin-right: 16px;
  border-bottom: 2px solid transparent;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  &:hover {
    border-color: #fff;
  }
}
.menu-item.menu-active {
  border-color: #fff;
}
.select-language {
  font-size: 13px;
  color: #fff;
  height: 56px;
  line-height: 56px;
  cursor: pointer;
  margin-right: 18px;
}
.user-wrapper {
  font-size: 13px;
  color: #fff;
  height: 56px;
  line-height: 56px;
  cursor: pointer;
}
.login-link {
  color: #fff;
}
.logout-link {
  display: block;
  color: #606266;
  &:hover {
    color: #0058a3;
  }
}
</style>

<style lang="scss">
.el-dropdown-menu.top-bar-dropdown {
  padding: 6px 0;
  margin: 6px;
}
</style>

